import { z } from 'zod';

export const TSDDuplicateDataSchema = z.object({
  tsdId: z.string(),
  name: z.string(),
});
export type TSDDuplicateData = z.infer<typeof TSDDuplicateDataSchema>;
